import {Component, EventEmitter, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Category} from "projects/store/src/app/enums";

@Component({
  selector: 'app-sales-additional-information',
  templateUrl: './sales-additional-information.component.html'
})
export class SalesAdditionalInformationComponent {
  requestId: string;
  additionalDataValues: any;
  categoryCode: string;

  @Output() nextStepEvent = new EventEmitter();

  constructor(private route: ActivatedRoute) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  protected readonly Category = Category;
}
